module.exports = __webpack_public_path__ + "img/body-3-lg.fb287072.png";